import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { GlobalContextThemeProvider } from "./contexts/globalcontext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <GlobalContextThemeProvider>
            <App />
        </GlobalContextThemeProvider>
    </React.StrictMode>
);
